module.exports = __webpack_public_path__ + "img/1F1FE-1F1EA.73a95860.svg";